export default __webpack_public_path__ + "static/media/optimization.f40299cf.svg";